/**
 * Navigation state passed via react-router to switch the environment
 * detail view mode on arrival (e.g. from the command palette).
 */
export type EnvironmentDetailsNavState = {
    switchToDetails?: boolean;
    switchToVscode?: boolean;
    preferredAgentExecutionId?: string;
};

/** Pre-built state objects to avoid object-literal allocation at every call site. */
export const NAV_STATE_DETAILS: { state: EnvironmentDetailsNavState } = {
    state: { switchToDetails: true },
};

export const NAV_STATE_VSCODE: { state: EnvironmentDetailsNavState } = {
    state: { switchToVscode: true },
};

/**
 * Runtime type guard for location.state coming from react-router.
 * Returns null if the value isn't a plausible EnvironmentDetailsNavState.
 */
export function asNavState(raw: unknown): EnvironmentDetailsNavState | null {
    if (raw == null || typeof raw !== "object") return null;
    const obj = raw as Record<string, unknown>;
    if (typeof obj.switchToDetails !== "undefined" && typeof obj.switchToDetails !== "boolean") return null;
    if (typeof obj.switchToVscode !== "undefined" && typeof obj.switchToVscode !== "boolean") return null;
    if (
        typeof obj.preferredAgentExecutionId !== "undefined" &&
        typeof obj.preferredAgentExecutionId !== "string"
    ) {
        return null;
    }
    if (obj.switchToDetails || obj.switchToVscode || typeof obj.preferredAgentExecutionId === "string") {
        return raw as EnvironmentDetailsNavState;
    }
    return null;
}
